import { useOutlet } from 'react-router-dom';
import { Header } from '../../../components/Header';

import { useCheckToken } from '../../auth/hooks/useCheckToken';
import { Spinner } from '../../../components/Spinner';
import { sendToWs, useGetChatConnectionQuery } from '../../chat/api/chatApi';
import { useSelector } from 'react-redux';
import { authSelector } from '../../auth/state/authSlice';
import { useEffect } from 'react';
import { ChatMessageTypes } from '../../chat/api/types';
import { useIsRoute } from '../../../hooks/useIsRoute';
import clsx from 'clsx';
import { Footer } from '../../../components/Footer';

export const LandingLayout = () => {
  const outlet = useOutlet();
  const { loadingToken } = useCheckToken();
  const { token } = useSelector(authSelector);

  const { data } = useGetChatConnectionQuery(undefined, { skip: !token });

  const isLandingPage = useIsRoute('/');

  useEffect(() => {
    if (data?.isConnected) {
      sendToWs({ msg_type: ChatMessageTypes.TotalUnreadCount });
    }
  }, [data?.isConnected]);

  if (loadingToken) return <Spinner />;

  return (
    <div className="min-h-screen bg-slate-100">
      <Header isConnected={data?.isConnected} totalUnread={data?.totalUnread} />
      {loadingToken ? (
        <div className="">
          <Spinner />
        </div>
      ) : (
        <div
          className={clsx(
            'mx-auto min-h-[79vh]',
            isLandingPage ? 'w-full' : 'max-w-screen-xl p-2 sm:p-4'
          )}>
          {outlet}
        </div>
      )}
      <Footer />
    </div>
  );
};
